/**
 * Private modules
 */
const {
  createQueryComponent,
  identity,
  objectIds,
  systemId,
  systemPermissionType,
} = require('../.private').components;

/**
 * Scopes
 */
const { DEFAULT } = require('../../scopes');

module.exports = {
  createSystemPermission: {
    properties: {
      body: {
        properties: {
          identity,
          type: systemPermissionType,
        },
        required: [
          'identity',
          'type',
        ],
        type: 'object',
      },
      params: {
        properties: {
          systemId,
        },
        required: ['systemId'],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  deleteSystemPermissions: {
    properties: {
      body: {
        properties: {
          objectIds,
        },
        required: ['objectIds'],
        type: 'object',
      },
      params: {
        properties: {
          systemId,
        },
        required: ['systemId'],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  getSystemPermissions: {
    properties: {
      params: {
        properties: {
          systemId,
        },
        required: ['systemId'],
        type: 'object',
      },
      query: createQueryComponent([DEFAULT]),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
};
